'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');

var sizes = [0, 40, 35, 30, 25, 20, 15];

var getFontSize = function getFontSize(_ref) {
  var level = _ref.level;
  return "".concat(sizes[level], "px");
};

var getFontColor = function getFontColor(_ref2) {
  var theme = _ref2.theme;
  return theme.dark ? universal_color.mlbWhite : universal_color.mlbGrey7;
};

var HeadlineWrapper = styled__default.h1.withConfig({
  displayName: "headlinestyle__HeadlineWrapper",
  componentId: "sc-1ccyctx-0"
})(["font-family:", ";font-size:", ";color:", ";h5&{font-weight:normal;}margin:0;"], function (_ref3) {
  var _theme$fonts, _theme$fonts$family;

  var _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? {} : _ref3$theme;
  return (_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : (_theme$fonts$family = _theme$fonts.family) === null || _theme$fonts$family === void 0 ? void 0 : _theme$fonts$family.primary;
}, getFontSize, getFontColor);
var SkeletonWrapper = styled__default.div.withConfig({
  displayName: "headlinestyle__SkeletonWrapper",
  componentId: "sc-1ccyctx-1"
})(["height:", ";"], getFontSize);

exports.HeadlineWrapper = HeadlineWrapper;
exports.SkeletonWrapper = SkeletonWrapper;
